var lib_core = require("lib-core");

var EllipseToolStateMachine = require("./ellipseToolStateMachine.js");
var AbstractToolController = require("./../../../extensions/abstractToolController.js");

if(typeof window !== 'undefined')
    var ui_extensions = require("ui-extensions");

var EllipseToolController = function(archLayers, dependencies, configuration) {
    this.setDefaultConfiguration({
        flip: 1,
        fill: false,
        strokeWidth: 2
    });

    AbstractToolController.call(this, archLayers, dependencies, configuration);
};
lib_core.inherit(EllipseToolController, AbstractToolController);
EllipseToolController.inject = AbstractToolController.inject;
EllipseToolController.StateMachineClass = EllipseToolStateMachine;

module.exports = EllipseToolController;

EllipseToolController.prototype.getButtonElements = function () {
    var buttonElements = {
        name: 'Ellipse',
        title: 'Ellipse',
        style: {
            icon: 'icon-circle.svg',
        },
        eventData: {
            "tool": this.name()
        },
        auto_escape: true
    };

    return buttonElements;
};
